import React from 'react';
import Select2Wrap from 'client/components/Form/Select2Wrap';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import propTypes from 'prop-types';
import { ButtonWaiting } from 'client/components/Button/ButtonWaiting';
import MaybeBeFormFieldError from 'client/components/Be/MaybeBeFormFieldError';

export default class FormFieldStatus extends React.Component {

  static propTypes = {
    base: propTypes.string.isRequired,
    dropdownParent: propTypes.string,
    data: propTypes.array.isRequired,
  };

  render () {
    const { defaultValue, input, meta, base, dropdownParent, data } = this.props;
    const { dirty, submitting } = meta;
    const id = `${base}-status`;
    return (
      <FormGroup controlId={id}>
        <ControlLabel bsClass="control-label">Status</ControlLabel>
        <div className="input-group">
          <Select2Wrap
            id={id}
            name="status"
            className="form-control"
            data={data}
            options={{minimumResultsForSearch: 20, dropdownParent}}
            defaultValue={defaultValue}
            {...input}
          />
          <span className="input-group-btn">
            <ButtonWaiting type="submit" disabled={!dirty} className="btn btn-primary" isWaiting={submitting}>Set status</ButtonWaiting>
          </span>
        </div>
        <FormControl.Feedback />
        <MaybeBeFormFieldError {...meta} />
      </FormGroup>
    );
  }

}
